import axios from "axios"

const linkTokenApi = () => {
    return axios.create({
        baseURL: process.env.REACT_APP_GRIZZLY_API_URL,
    })
}

export default linkTokenApi()
